<template>
    <div class="float-menu-container">
        <!-- 展开状态 - 菜单面板 -->
        <transition name="fade">
            <div v-if="isOpen" class="menu-panel">
                <div class="menu-row" v-for="(group, g_index) in menuList">
                    <div v-for="item in group" :key="item.value" class="menu-item" :class="{ disabled: item.disabled }"
                        @click="handleMenuClick(item)">
                        {{ item.label }}
                    </div>
                </div>
            </div>
        </transition>

        <!-- 控制按钮 -->
        <div class="control-btn" :class="{ 'is-open': isOpen }" @click="toggleMenu">
            <span v-if="!isOpen">?</span>
            <span v-else>X</span>
        </div>
    </div>
</template>

<script>
import { hasAuth } from '@/utils/uEdition';
import { mapGetters } from 'vuex';

export default {
    name: 'FloatMenu',
    props: {
        info: {
            type: Object,
            default: () => { },
        },
        isPrescription: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            isOpen: false,

        };
    },
    computed: {
        ...mapGetters([
            "hideAi",
            "addMedicalRecordSymptom",
            "is999",
        ]),
        recordSymptom() {
            return this.addMedicalRecordSymptom[this.info.registerCode] || [];
        },
        menuList() {
            let list = [
                [
                    {
                        label: "五运六气",
                        value: "wuyunliuqi",
                        hasAuth: hasAuth("YZ-02"),
                        disabled: false,
                    },
                    {
                        label: "手相",
                        value: "shouxiang",
                        hasAuth: hasAuth("YZ-01"),
                        disabled: false,
                    },
                    {
                        label: "西医报告",
                        value: "xiyibaogao",
                        hasAuth: hasAuth("YZ-05"),
                        disabled: false,
                    },
                    {
                        label: "话术方向",
                        value: "huashufangxiang",
                        hasAuth: hasAuth("YZ-06"),
                        disabled: false,
                    },
                ],
                [
                    {
                        label: "病因分析",
                        value: "bingyinfenxi",
                        hasAuth: hasAuth("YZ-03"),
                        disabled: false,
                        disabled: !this.isPrescription,
                    },
                    {
                        label: "成功病案",
                        value: "successfulMedicalCase",
                        hasAuth: hasAuth("YZ-10") && this.is999,
                        disabled: false,
                        disabled: !this.isPrescription,
                    },
                    {
                        label: "病案分析workflow报告",
                        value: "bingyinfenxiWorkFlow",
                        hasAuth: hasAuth("YZ-35") && this.is999,
                        disabled: false,
                        disabled: !this.isPrescription,
                    },
                ],
                [
                    {
                        label: "推荐处方",
                        value: "tuijianchufang",
                        hasAuth: true,
                        disabled: !this.isPrescription,
                    },
                    // {
                    //     label: "更多处方",
                    //     value: "gengduochufang",
                    //     hasAuth: true,
                    //     disabled: !(this.isPrescription && this.recordSymptom.length > 1),
                    // },
                    {
                        label: "医嘱禁忌",
                        value: "yizhujinji",
                        hasAuth: true,
                        disabled: !this.isPrescription,
                    }
                ]
            ];
            let arr = [];
            list.forEach((group, g_index) => {
                let r = group.filter(i => i.hasAuth)
                if (r.length > 0) {
                    arr.push(r);
                }
            });
            return arr;
        }
    },
    mounted() {
        document.addEventListener('click', this.handleOutsideClick);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleOutsideClick);
    },
    methods: {
        toggleMenu() {
            this.isOpen = !this.isOpen;
        },
        handleMenuClick(item) {
            if (item.disabled) return;
            this.isOpen = false;
            this.$bus.emit("HIDEAI", item.value);
        },
        handleOutsideClick(event) {
            const container = this.$el;
            if (container && !container.contains(event.target)) {
                this.isOpen = false;
            }
        }
    }
};
</script>

<style scoped lang="scss">
.float-menu-container {
    position: absolute;
    bottom: 30px;
    right: 30px;
    z-index: 999;
}

.menu-panel {
    position: absolute;
    bottom: 50px;
    right: 0;
    width: 350px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    padding: 16px 0;
    display: flex;
    flex-direction: column;
}

.menu-row {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;

    &+.menu-row {
        border-top: 1px solid #eee;
    }
}

.menu-item {
    padding: 5px 15px;
    font-size: 14px;
    color: #333333;
    cursor: pointer;
    transition: all 0.2s ease;
    border-radius: 5px;
}

.menu-item:hover:not(.disabled) {
    background-color: #f5f5f5;
}

.menu-item.disabled {
    color: #cccccc;
    cursor: not-allowed;
}

.menu-divider {
    height: 1px;
    background-color: #eeeeee;
    margin: 8px 0;
}

.control-btn {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #fff;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;

    span {
        display: inline-block;
        height: 14px;
        line-height: 14px;
    }
}

.control-btn:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(74, 144, 217, 0.5);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
    transform: translateY(10px);
}
</style>